<template>
  <div>
    <CWidgetProgress>
      <div class="text-center h4 m-0" v-if="type=='single'" style="font-weight: bold;font-size: 23px;">
        {{ count }}
      </div>
      <div class="text-center h4 m-0" v-if="type=='double'" style="font-weight: bold;font-size: 23px;">
        {{ count }}
<!--        | {{ countNew }}-->
      </div>
<!--      <div class="card-header-actions">-->
<!--        <a href="https://coreui.io/vue/docs/components/widgets" class="card-header-action position-absolute" style="right:5px; top:5px" rel="noreferrer noopener" target="_blank">-->
<!--          <small class="text-muted">more</small>-->
<!--        </a>-->
<!--      </div>-->
      <CProgress :color="getClass(color)" :valueExportResourceData="100" class="progress-xs my-3 mb-0" />
        <div style="color: gray;" class="text-center">
          <b>
            <!-- <a class="text-muted" :href="link" target="_blank"> -->
              <a class="text-muted" @click="setFilters" target="_blank">
              {{ text }}
            </a>
          </b>
        </div>
    </CWidgetProgress>

    <!-- <div :class="getClass(color)">
      <div class="card-body">
        <div class="fw-semibold text-uppercase1" style="font-size:20px;text-align: center;">{{ text }}</div>
        <hr style="border: 0.5px solid white;">
        <div v-if="type == 'single'" class="fw-semibold text-white text-opacity-75"
          style="font-size: 18px;text-align: center;">{{ count }}</div>
        <div v-if="type == 'double'" class="fw-semibold text-white text-opacity-75" style="font-size: 18px;">
          <div class="table1">
            <div class="tr">
              <div class="d2">{{ count }} | {{ countNew }}</div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
  </div>

</template>
<script>
import { Mixin } from "/src/mixins/index.js";
import { CIcon } from '@coreui/icons-vue'
import * as icon from '@coreui/icons';

export default {
  name: "DashboardBlocks",
  mixins: [Mixin],
  components: { CIcon },
  props: ["startDate","module","endDate","text", "icon", "color", "count", "type","link"],
  data() {
    return {
      largeModal: false,
      self: this,
    };
  },
  methods: {
    getClass(color) {
      return "gradient-" + color;
    },
    setFilters() {
      let self = this;
      var formData = {
        "startDate" : self.startDate,
        "endDate" : self.endDate,
        "status" : self.text,
        "module" : self.module,
      };
      localStorage.setItem(self.module,JSON.stringify(formData));
      const routeData = this.$router.resolve({ path: self.link });
      window.open(routeData.href, '_blank');
    }
  }
};
</script>
<style>
.fw-semibold {
  font-weight: 600 !important;
}

.fs-4 {
  font-size: calc(1.275rem + .3vw) !important;
}

.text-opacity-75 {
  --cui-text-opacity: .75;
}

.table1 {
  display: table;
  margin-bottom: none;
  width: 100%;
}

.tr {
  display: table-row;
  /* color: white; */
}

.d1 {
  display: table-cell;
  width: 25%;
}

.d2 {
  display: table-cell;
  text-align: center;
  width: 50%;
}

.d3 {
  display: table-cell;
  text-align: right;
  width: 25%;
}
</style>